import { SET_USERNAME, SET_PASSWORD, GET_DETAILS } from "./actionType";

export const setUsername = (username) => {
    return {
        type: SET_USERNAME,
        payload: username,
    };
};

export const setPassword = (password) => {
    return {
        type: SET_PASSWORD,
        payload: password,
    };
};

export const getAdminDetails = (adminDetails) => {
    return {
        type: GET_DETAILS,
        payload: adminDetails,
   };
};